// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/app/v1/app_usage.proto" (package "c1.api.app.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { App } from "./app";
import { Any } from "../../../../google/protobuf/any";
import { AppUserView } from "./app_user";
import { AppUserExpandMask } from "./app_user";
import { FieldMask } from "../../../../google/protobuf/field_mask";
/**
 * The AppUsageControls object describes some peripheral configuration for an app.
 *
 * @generated from protobuf message c1.api.app.v1.AppUsageControls
 */
export interface AppUsageControls {
    /**
     * The app that this object belongs to.
     *
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * Whether or not to notify some if they have access to the app, but has not used it within a configurable amount of time.
     *
     * @generated from protobuf field: bool notify = 2
     */
    notify: boolean;
    /**
     * The duration in days after which we notify users of nonusage.
     *
     * @generated from protobuf field: uint32 notify_after_days = 3
     */
    notifyAfterDays: number;
    /**
     * Whether or not to revoke a grant if they have access to the app, but has not used it within a configurable amount of time.
     *
     * @generated from protobuf field: bool revoke = 4
     */
    revoke: boolean;
    /**
     * The duration in days after which we revoke users that have not used that grant.
     *
     * @generated from protobuf field: uint32 revoke_after_days = 5
     */
    revokeAfterDays: number;
}
/**
 * @generated from protobuf message c1.api.app.v1.GetAppUsageControlsRequest
 */
export interface GetAppUsageControlsRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
}
/**
 * The GetAppUsageControlsResponse message contains the retrieved AppUsageControls object.
 *
 * @generated from protobuf message c1.api.app.v1.GetAppUsageControlsResponse
 */
export interface GetAppUsageControlsResponse {
    /**
     * The AppUsageControls is null if HasUsageData is false, or data if it's true.
     *
     * @generated from protobuf field: c1.api.app.v1.AppUsageControls app_usage_controls = 1
     */
    appUsageControls?: AppUsageControls;
    /**
     * HasUsageData is false if the access entitlement for this app has no usage data.
     *
     * @generated from protobuf field: bool has_usage_data = 2
     */
    hasUsageData: boolean;
}
/**
 * The UpdateAppUsageControlsRequest message contains the AppUsageControls object to update and the update mask.
 *
 * @generated from protobuf message c1.api.app.v1.UpdateAppUsageControlsRequest
 */
export interface UpdateAppUsageControlsRequest {
    /**
     * The app usage controls object to update the request with.
     *
     * @generated from protobuf field: c1.api.app.v1.AppUsageControls app_usage_controls = 1
     */
    appUsageControls?: AppUsageControls;
    /**
     * A comma-separated list of fields to update in the destination. To update just the notify, it would look like "notify,notify_after_days".
     *
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 2
     */
    updateMask?: FieldMask;
}
/**
 * The UpdateAppUsageControlsResponse message contains the updated AppUsageControls object.
 *
 * @generated from protobuf message c1.api.app.v1.UpdateAppUsageControlsResponse
 */
export interface UpdateAppUsageControlsResponse {
    /**
     * The AppUsageControls object that was updated.
     *
     * @generated from protobuf field: c1.api.app.v1.AppUsageControls app_usage_controls = 1
     */
    appUsageControls?: AppUsageControls;
}
/**
 * @generated from protobuf message c1.api.app.v1.GetNotLoggedInCountRequest
 */
export interface GetNotLoggedInCountRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: uint32 days = 2
     */
    days: number;
}
/**
 * @generated from protobuf message c1.api.app.v1.GetNotLoggedInCountResponse
 */
export interface GetNotLoggedInCountResponse {
    /**
     * @generated from protobuf field: uint32 count = 1
     */
    count: number;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchInactiveUsersRequest
 */
export interface SearchInactiveUsersRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_owner_id = 2
     */
    appOwnerId: string;
    /**
     * @generated from protobuf field: uint32 days = 3
     */
    days: number;
    /**
     * @generated from protobuf field: int32 page_size = 4
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 5
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUserExpandMask expand_mask = 6
     */
    expandMask?: AppUserExpandMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchInactiveUsersResponse
 */
export interface SearchInactiveUsersResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppUserView list = 1
     */
    list: AppUserView[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.app.v1.AppWithUserCount
 */
export interface AppWithUserCount {
    /**
     * @generated from protobuf field: c1.api.app.v1.App App = 1
     */
    app?: App;
    /**
     * @generated from protobuf field: int64 Count = 2
     */
    count: number;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchInactiveUsersPastThirtyDaysForAllAppsRequest
 */
export interface SearchInactiveUsersPastThirtyDaysForAllAppsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchInactiveUsersPastThirtyDaysForAllAppsResponse
 */
export interface SearchInactiveUsersPastThirtyDaysForAllAppsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppWithUserCount list = 1
     */
    list: AppWithUserCount[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.CountInactiveUsersPastThirtyDaysRequest
 */
export interface CountInactiveUsersPastThirtyDaysRequest {
}
/**
 * @generated from protobuf message c1.api.app.v1.CountInactiveUsersPastThirtyDaysResponse
 */
export interface CountInactiveUsersPastThirtyDaysResponse {
    /**
     * @generated from protobuf field: int64 total_count = 1
     */
    totalCount: number;
}
/**
 * @generated from protobuf message c1.api.app.v1.CountInactiveUsersForAppRequest
 */
export interface CountInactiveUsersForAppRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.CountInactiveUsersForAppResponse
 */
export interface CountInactiveUsersForAppResponse {
    /**
     * @generated from protobuf field: int64 count = 1
     */
    count: number;
}
// @generated message type with reflection information, may provide speed optimized methods
class AppUsageControls$Type extends MessageType<AppUsageControls> {
    constructor() {
        super("c1.api.app.v1.AppUsageControls", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "notify", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "notify_after_days", kind: "scalar", T: 13 /*ScalarType.UINT32*/, options: { "validate.rules": { uint32: { lte: 500, gte: 0 } } } },
            { no: 4, name: "revoke", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "revoke_after_days", kind: "scalar", T: 13 /*ScalarType.UINT32*/, options: { "validate.rules": { uint32: { lte: 500, gte: 0 } } } }
        ]);
    }
    create(value?: PartialMessage<AppUsageControls>): AppUsageControls {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.notify = false;
        message.notifyAfterDays = 0;
        message.revoke = false;
        message.revokeAfterDays = 0;
        if (value !== undefined)
            reflectionMergePartial<AppUsageControls>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppUsageControls): AppUsageControls {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* bool notify */ 2:
                    message.notify = reader.bool();
                    break;
                case /* uint32 notify_after_days */ 3:
                    message.notifyAfterDays = reader.uint32();
                    break;
                case /* bool revoke */ 4:
                    message.revoke = reader.bool();
                    break;
                case /* uint32 revoke_after_days */ 5:
                    message.revokeAfterDays = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppUsageControls, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* bool notify = 2; */
        if (message.notify !== false)
            writer.tag(2, WireType.Varint).bool(message.notify);
        /* uint32 notify_after_days = 3; */
        if (message.notifyAfterDays !== 0)
            writer.tag(3, WireType.Varint).uint32(message.notifyAfterDays);
        /* bool revoke = 4; */
        if (message.revoke !== false)
            writer.tag(4, WireType.Varint).bool(message.revoke);
        /* uint32 revoke_after_days = 5; */
        if (message.revokeAfterDays !== 0)
            writer.tag(5, WireType.Varint).uint32(message.revokeAfterDays);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUsageControls
 */
export const AppUsageControls = new AppUsageControls$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAppUsageControlsRequest$Type extends MessageType<GetAppUsageControlsRequest> {
    constructor() {
        super("c1.api.app.v1.GetAppUsageControlsRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<GetAppUsageControlsRequest>): GetAppUsageControlsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        if (value !== undefined)
            reflectionMergePartial<GetAppUsageControlsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAppUsageControlsRequest): GetAppUsageControlsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAppUsageControlsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.GetAppUsageControlsRequest
 */
export const GetAppUsageControlsRequest = new GetAppUsageControlsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAppUsageControlsResponse$Type extends MessageType<GetAppUsageControlsResponse> {
    constructor() {
        super("c1.api.app.v1.GetAppUsageControlsResponse", [
            { no: 1, name: "app_usage_controls", kind: "message", T: () => AppUsageControls },
            { no: 2, name: "has_usage_data", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<GetAppUsageControlsResponse>): GetAppUsageControlsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.hasUsageData = false;
        if (value !== undefined)
            reflectionMergePartial<GetAppUsageControlsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAppUsageControlsResponse): GetAppUsageControlsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppUsageControls app_usage_controls */ 1:
                    message.appUsageControls = AppUsageControls.internalBinaryRead(reader, reader.uint32(), options, message.appUsageControls);
                    break;
                case /* bool has_usage_data */ 2:
                    message.hasUsageData = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAppUsageControlsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppUsageControls app_usage_controls = 1; */
        if (message.appUsageControls)
            AppUsageControls.internalBinaryWrite(message.appUsageControls, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool has_usage_data = 2; */
        if (message.hasUsageData !== false)
            writer.tag(2, WireType.Varint).bool(message.hasUsageData);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.GetAppUsageControlsResponse
 */
export const GetAppUsageControlsResponse = new GetAppUsageControlsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateAppUsageControlsRequest$Type extends MessageType<UpdateAppUsageControlsRequest> {
    constructor() {
        super("c1.api.app.v1.UpdateAppUsageControlsRequest", [
            { no: 1, name: "app_usage_controls", kind: "message", T: () => AppUsageControls, options: { "validate.rules": { message: { skip: true } } } },
            { no: 2, name: "update_mask", kind: "message", T: () => FieldMask }
        ]);
    }
    create(value?: PartialMessage<UpdateAppUsageControlsRequest>): UpdateAppUsageControlsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateAppUsageControlsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateAppUsageControlsRequest): UpdateAppUsageControlsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppUsageControls app_usage_controls */ 1:
                    message.appUsageControls = AppUsageControls.internalBinaryRead(reader, reader.uint32(), options, message.appUsageControls);
                    break;
                case /* google.protobuf.FieldMask update_mask */ 2:
                    message.updateMask = FieldMask.internalBinaryRead(reader, reader.uint32(), options, message.updateMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateAppUsageControlsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppUsageControls app_usage_controls = 1; */
        if (message.appUsageControls)
            AppUsageControls.internalBinaryWrite(message.appUsageControls, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.FieldMask update_mask = 2; */
        if (message.updateMask)
            FieldMask.internalBinaryWrite(message.updateMask, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.UpdateAppUsageControlsRequest
 */
export const UpdateAppUsageControlsRequest = new UpdateAppUsageControlsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateAppUsageControlsResponse$Type extends MessageType<UpdateAppUsageControlsResponse> {
    constructor() {
        super("c1.api.app.v1.UpdateAppUsageControlsResponse", [
            { no: 1, name: "app_usage_controls", kind: "message", T: () => AppUsageControls }
        ]);
    }
    create(value?: PartialMessage<UpdateAppUsageControlsResponse>): UpdateAppUsageControlsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateAppUsageControlsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateAppUsageControlsResponse): UpdateAppUsageControlsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppUsageControls app_usage_controls */ 1:
                    message.appUsageControls = AppUsageControls.internalBinaryRead(reader, reader.uint32(), options, message.appUsageControls);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateAppUsageControlsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppUsageControls app_usage_controls = 1; */
        if (message.appUsageControls)
            AppUsageControls.internalBinaryWrite(message.appUsageControls, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.UpdateAppUsageControlsResponse
 */
export const UpdateAppUsageControlsResponse = new UpdateAppUsageControlsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetNotLoggedInCountRequest$Type extends MessageType<GetNotLoggedInCountRequest> {
    constructor() {
        super("c1.api.app.v1.GetNotLoggedInCountRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "days", kind: "scalar", T: 13 /*ScalarType.UINT32*/, options: { "validate.rules": { uint32: { lte: 366, gte: 0 } } } }
        ]);
    }
    create(value?: PartialMessage<GetNotLoggedInCountRequest>): GetNotLoggedInCountRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.days = 0;
        if (value !== undefined)
            reflectionMergePartial<GetNotLoggedInCountRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetNotLoggedInCountRequest): GetNotLoggedInCountRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* uint32 days */ 2:
                    message.days = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetNotLoggedInCountRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* uint32 days = 2; */
        if (message.days !== 0)
            writer.tag(2, WireType.Varint).uint32(message.days);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.GetNotLoggedInCountRequest
 */
export const GetNotLoggedInCountRequest = new GetNotLoggedInCountRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetNotLoggedInCountResponse$Type extends MessageType<GetNotLoggedInCountResponse> {
    constructor() {
        super("c1.api.app.v1.GetNotLoggedInCountResponse", [
            { no: 1, name: "count", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<GetNotLoggedInCountResponse>): GetNotLoggedInCountResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.count = 0;
        if (value !== undefined)
            reflectionMergePartial<GetNotLoggedInCountResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetNotLoggedInCountResponse): GetNotLoggedInCountResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 count */ 1:
                    message.count = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetNotLoggedInCountResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 count = 1; */
        if (message.count !== 0)
            writer.tag(1, WireType.Varint).uint32(message.count);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.GetNotLoggedInCountResponse
 */
export const GetNotLoggedInCountResponse = new GetNotLoggedInCountResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchInactiveUsersRequest$Type extends MessageType<SearchInactiveUsersRequest> {
    constructor() {
        super("c1.api.app.v1.SearchInactiveUsersRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_owner_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$", ignoreEmpty: true } } } },
            { no: 3, name: "days", kind: "scalar", T: 13 /*ScalarType.UINT32*/, options: { "validate.rules": { uint32: { lte: 366, gte: 0 } } } },
            { no: 4, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 5, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 6, name: "expand_mask", kind: "message", T: () => AppUserExpandMask }
        ]);
    }
    create(value?: PartialMessage<SearchInactiveUsersRequest>): SearchInactiveUsersRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.appOwnerId = "";
        message.days = 0;
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<SearchInactiveUsersRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchInactiveUsersRequest): SearchInactiveUsersRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string app_owner_id */ 2:
                    message.appOwnerId = reader.string();
                    break;
                case /* uint32 days */ 3:
                    message.days = reader.uint32();
                    break;
                case /* int32 page_size */ 4:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 5:
                    message.pageToken = reader.string();
                    break;
                case /* c1.api.app.v1.AppUserExpandMask expand_mask */ 6:
                    message.expandMask = AppUserExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchInactiveUsersRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string app_owner_id = 2; */
        if (message.appOwnerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appOwnerId);
        /* uint32 days = 3; */
        if (message.days !== 0)
            writer.tag(3, WireType.Varint).uint32(message.days);
        /* int32 page_size = 4; */
        if (message.pageSize !== 0)
            writer.tag(4, WireType.Varint).int32(message.pageSize);
        /* string page_token = 5; */
        if (message.pageToken !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.pageToken);
        /* c1.api.app.v1.AppUserExpandMask expand_mask = 6; */
        if (message.expandMask)
            AppUserExpandMask.internalBinaryWrite(message.expandMask, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchInactiveUsersRequest
 */
export const SearchInactiveUsersRequest = new SearchInactiveUsersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchInactiveUsersResponse$Type extends MessageType<SearchInactiveUsersResponse> {
    constructor() {
        super("c1.api.app.v1.SearchInactiveUsersResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppUserView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<SearchInactiveUsersResponse>): SearchInactiveUsersResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<SearchInactiveUsersResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchInactiveUsersResponse): SearchInactiveUsersResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.AppUserView list */ 1:
                    message.list.push(AppUserView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                case /* repeated google.protobuf.Any expanded */ 3:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchInactiveUsersResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.AppUserView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AppUserView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        /* repeated google.protobuf.Any expanded = 3; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchInactiveUsersResponse
 */
export const SearchInactiveUsersResponse = new SearchInactiveUsersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppWithUserCount$Type extends MessageType<AppWithUserCount> {
    constructor() {
        super("c1.api.app.v1.AppWithUserCount", [
            { no: 1, name: "App", kind: "message", jsonName: "App", T: () => App },
            { no: 2, name: "Count", kind: "scalar", jsonName: "Count", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<AppWithUserCount>): AppWithUserCount {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.count = 0;
        if (value !== undefined)
            reflectionMergePartial<AppWithUserCount>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppWithUserCount): AppWithUserCount {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.App App */ 1:
                    message.app = App.internalBinaryRead(reader, reader.uint32(), options, message.app);
                    break;
                case /* int64 Count */ 2:
                    message.count = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppWithUserCount, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.App App = 1; */
        if (message.app)
            App.internalBinaryWrite(message.app, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int64 Count = 2; */
        if (message.count !== 0)
            writer.tag(2, WireType.Varint).int64(message.count);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppWithUserCount
 */
export const AppWithUserCount = new AppWithUserCount$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchInactiveUsersPastThirtyDaysForAllAppsRequest$Type extends MessageType<SearchInactiveUsersPastThirtyDaysForAllAppsRequest> {
    constructor() {
        super("c1.api.app.v1.SearchInactiveUsersPastThirtyDaysForAllAppsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<SearchInactiveUsersPastThirtyDaysForAllAppsRequest>): SearchInactiveUsersPastThirtyDaysForAllAppsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<SearchInactiveUsersPastThirtyDaysForAllAppsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchInactiveUsersPastThirtyDaysForAllAppsRequest): SearchInactiveUsersPastThirtyDaysForAllAppsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchInactiveUsersPastThirtyDaysForAllAppsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchInactiveUsersPastThirtyDaysForAllAppsRequest
 */
export const SearchInactiveUsersPastThirtyDaysForAllAppsRequest = new SearchInactiveUsersPastThirtyDaysForAllAppsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchInactiveUsersPastThirtyDaysForAllAppsResponse$Type extends MessageType<SearchInactiveUsersPastThirtyDaysForAllAppsResponse> {
    constructor() {
        super("c1.api.app.v1.SearchInactiveUsersPastThirtyDaysForAllAppsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppWithUserCount },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchInactiveUsersPastThirtyDaysForAllAppsResponse>): SearchInactiveUsersPastThirtyDaysForAllAppsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<SearchInactiveUsersPastThirtyDaysForAllAppsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchInactiveUsersPastThirtyDaysForAllAppsResponse): SearchInactiveUsersPastThirtyDaysForAllAppsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.AppWithUserCount list */ 1:
                    message.list.push(AppWithUserCount.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchInactiveUsersPastThirtyDaysForAllAppsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.AppWithUserCount list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AppWithUserCount.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchInactiveUsersPastThirtyDaysForAllAppsResponse
 */
export const SearchInactiveUsersPastThirtyDaysForAllAppsResponse = new SearchInactiveUsersPastThirtyDaysForAllAppsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CountInactiveUsersPastThirtyDaysRequest$Type extends MessageType<CountInactiveUsersPastThirtyDaysRequest> {
    constructor() {
        super("c1.api.app.v1.CountInactiveUsersPastThirtyDaysRequest", []);
    }
    create(value?: PartialMessage<CountInactiveUsersPastThirtyDaysRequest>): CountInactiveUsersPastThirtyDaysRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CountInactiveUsersPastThirtyDaysRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CountInactiveUsersPastThirtyDaysRequest): CountInactiveUsersPastThirtyDaysRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CountInactiveUsersPastThirtyDaysRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.CountInactiveUsersPastThirtyDaysRequest
 */
export const CountInactiveUsersPastThirtyDaysRequest = new CountInactiveUsersPastThirtyDaysRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CountInactiveUsersPastThirtyDaysResponse$Type extends MessageType<CountInactiveUsersPastThirtyDaysResponse> {
    constructor() {
        super("c1.api.app.v1.CountInactiveUsersPastThirtyDaysResponse", [
            { no: 1, name: "total_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<CountInactiveUsersPastThirtyDaysResponse>): CountInactiveUsersPastThirtyDaysResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial<CountInactiveUsersPastThirtyDaysResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CountInactiveUsersPastThirtyDaysResponse): CountInactiveUsersPastThirtyDaysResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 total_count */ 1:
                    message.totalCount = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CountInactiveUsersPastThirtyDaysResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 total_count = 1; */
        if (message.totalCount !== 0)
            writer.tag(1, WireType.Varint).int64(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.CountInactiveUsersPastThirtyDaysResponse
 */
export const CountInactiveUsersPastThirtyDaysResponse = new CountInactiveUsersPastThirtyDaysResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CountInactiveUsersForAppRequest$Type extends MessageType<CountInactiveUsersForAppRequest> {
    constructor() {
        super("c1.api.app.v1.CountInactiveUsersForAppRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<CountInactiveUsersForAppRequest>): CountInactiveUsersForAppRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        if (value !== undefined)
            reflectionMergePartial<CountInactiveUsersForAppRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CountInactiveUsersForAppRequest): CountInactiveUsersForAppRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CountInactiveUsersForAppRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.CountInactiveUsersForAppRequest
 */
export const CountInactiveUsersForAppRequest = new CountInactiveUsersForAppRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CountInactiveUsersForAppResponse$Type extends MessageType<CountInactiveUsersForAppResponse> {
    constructor() {
        super("c1.api.app.v1.CountInactiveUsersForAppResponse", [
            { no: 1, name: "count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<CountInactiveUsersForAppResponse>): CountInactiveUsersForAppResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.count = 0;
        if (value !== undefined)
            reflectionMergePartial<CountInactiveUsersForAppResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CountInactiveUsersForAppResponse): CountInactiveUsersForAppResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 count */ 1:
                    message.count = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CountInactiveUsersForAppResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 count = 1; */
        if (message.count !== 0)
            writer.tag(1, WireType.Varint).int64(message.count);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.CountInactiveUsersForAppResponse
 */
export const CountInactiveUsersForAppResponse = new CountInactiveUsersForAppResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.app.v1.AppUsageControlsService
 */
export const AppUsageControlsService = new ServiceType("c1.api.app.v1.AppUsageControlsService", [
    { name: "Get", options: { "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/apps/{app_id}/usage_controls", group: "App Usage Controls" }] }, "authz.method": { role: "VIEWER" } }, I: GetAppUsageControlsRequest, O: GetAppUsageControlsResponse },
    { name: "Update", options: { "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/apps/{app_usage_controls.app_id}/usage_controls", group: "App Usage Controls" }] }, "authz.method": { role: "EDITOR" } }, I: UpdateAppUsageControlsRequest, O: UpdateAppUsageControlsResponse },
    { name: "GetNotLoggedInCount", options: { "authz.method": { role: "VIEWER" } }, I: GetNotLoggedInCountRequest, O: GetNotLoggedInCountResponse },
    { name: "SearchInactiveUsers", options: { "authz.method": { role: "VIEWER" } }, I: SearchInactiveUsersRequest, O: SearchInactiveUsersResponse },
    { name: "CountInactiveUsersPastThirtyDays", options: { "authz.method": { role: "VIEWER" } }, I: CountInactiveUsersPastThirtyDaysRequest, O: CountInactiveUsersPastThirtyDaysResponse },
    { name: "SearchInactiveUsersPastThirtyDaysForAllApps", options: { "authz.method": { role: "VIEWER" } }, I: SearchInactiveUsersPastThirtyDaysForAllAppsRequest, O: SearchInactiveUsersPastThirtyDaysForAllAppsResponse },
    { name: "CountInactiveUsersForApp", options: { "authz.method": { role: "VIEWER" } }, I: CountInactiveUsersForAppRequest, O: CountInactiveUsersForAppResponse }
]);
